import React from 'react';
import PriceDiff from 'components/Tvendo/Shopping/Operations/PriceDiff/PriceDiff';

export default function () {
  return <PriceDiff />;
}
